/**
 * Duas peças para busca que vai ao servidor a cada digitação (2026-09-25).
 *
 * O bug que motivou (Aproveitamento de Sobras): cada tecla disparava uma
 * requisição e a lista mostrava a resposta que chegasse POR ÚLTIMO — não a
 * da busca mais recente. Digitar "marul" mostrava os resultados de "mar".
 *
 * - `useValorComAtraso(valor, ms)`: devolve o valor só depois de `ms` sem
 *   mudança (debounce). Menos requisições enquanto a pessoa digita.
 * - `useRespostaMaisRecente()`: numera cada carga; a resposta de uma carga
 *   superada é descartada. Resolve o que o debounce sozinho não resolve:
 *   duas requisições ainda podem cruzar quando a API demora.
 *
 *   const iniciar = useRespostaMaisRecente();
 *   const vale = iniciar();            // antes do await
 *   const r = await listar(...);
 *   if (!vale()) return;               // chegou tarde: ignora
 */
import { useCallback, useEffect, useRef, useState } from "react";

export const ATRASO_BUSCA_MS = 300;

export function useValorComAtraso(valor, ms = ATRASO_BUSCA_MS) {
  const [atrasado, setAtrasado] = useState(valor);
  useEffect(() => {
    const t = setTimeout(() => setAtrasado(valor), ms);
    return () => clearTimeout(t);
  }, [valor, ms]);
  return atrasado;
}

export function useRespostaMaisRecente() {
  const sequencia = useRef(0);
  return useCallback(() => {
    sequencia.current += 1;
    const minha = sequencia.current;
    return () => minha === sequencia.current;
  }, []);
}
